module.exports = __webpack_public_path__ + "static/img/organilog-07.5223c8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/organilog-07.png
// module id = 124
// module chunks = 0